<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Ispeks Manual">

          
            
                  
            <w-card bg-color="" class="">
                <w-flex justify-space-between class="mb4">
                  
                <div class="xs3">
                    <w-input
                        v-model="cari.no_penyata_pemungut"
                        name="no_penyata_pemungut"
                        label="No Penyata Pemungut"
                        
                    />
                        <!-- <w-input v-model="cari.no_resit" label="No. Resit " />  -->
                </div>
                &nbsp;
                <div class="xs3">
                    <w-input
                        type="date"
                        v-model="cari.tarikh_lulus"
                        name="tarikh_lulus"
                        label="Tarikh Lulus"
                        
                    />
                        <!-- <w-input v-model="cari.no_resit" label="No. Resit " />  -->
                </div>
                &nbsp;
                <div class="xs3">
                     <z-lookup :url="service_kutipan +'lookup/jabatan_baharu'"
                    :sort="false"
                    :cache="false"
                    v-model="cari.jabatan_id"
                    label="Jabatan"
                />
                </div>
                &nbsp;
                <div class="xs3">
                     <z-lookup :url="service_utiliti +'lookup/cara_bayar'"
                    :sort="false"
                    :cache="false"
                    v-model="cari.lkp_cara_bayaran_id"
                    label="Cara Bayaran"
                    />
                </div>
                &nbsp;
                <div class="xs2">
                    <w-button class="ml1" v-on:click="reset()" :loading="cari.loading" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    &nbsp;
                     <w-button class="ml1 " @click="detail()" :loading="cari.loading">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
                </w-flex>
                <br><br>


                 <z-page title="Ispeks Manual">
                    <w-flex justify-center align-center class="mt5">
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Bil</td>
                                        <td>Jabatan</td>
                                        <td>No. Penyata Pemungut</td>
                                        <td>Tarikh</td>
                                        <td>Kaedah Bayaran</td>
                                        <td>No. Slip Bank</td>
                                        <td>Amaun (Rm)</td>
                                        <td>Status</td>
                                        <td>File Ispeks</td>
                                        <td>
                                            <w-checkbox v-model="pilih" @click="cekPilih"></w-checkbox>
                                            Tindakan
                                        </td>
                                    </tr>
                                  
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in pemungut">
                                    <!-- <tr> -->
                                        <td>{{(index+1)}}</td>
                                        <td>{{dt.jabatan}}</td>
                                        <td>{{dt.no_penyata_pemungut}}</td>
                                        <td>{{$zutil.dateformat(dt.tarikh_lulus)}}</td>
                                        <td>{{dt.bayaran}}</td>
                                        <td>{{dt.no_slip_bank}}</td>
                                        <td align="right">{{$zutil.currency(dt.amaun)}}</td>
                                        <td>{{dt.status}}</td>
                                        <td>{{dt.file_ispeks}}</td>
                                        <td>
                                            <!-- <template v-if="dt.tarikh_lulus != null && dt.file_ispeks == null"> -->
                                            <template v-if="dt.tarikh_lulus != null">
                                                <w-checkbox v-model="dt.pilih"></w-checkbox>
                                            </template>
                                           <!--  <w-button bg-color="success" class="mr3" @click="hantarIspeks(dt.id)">
                                                &nbsp;Hantar Ispeks
                                            </w-button> -->

                                        </td>
                                    </tr>
                                    <tr v-if="pemungut.length == 0">
                                       <td class="w-table__cell text-center" colspan="9">
                                        Tiada Data
                                       </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>

                    <div class="mt2 text-right">
                        <w-button bg-color="success" class="mr3" @click="hantar">
                            &nbsp;Hantar Ispeks
                        </w-button>
                       
                     </div>
                    <br>
                </z-page>

               
            </w-card>
                   


        </z-page>
    </zen-one>
    <w-overlay
          v-model="showOverlay"
          :persistent= true>
          
        <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
    </w-overlay>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan +'penyata_pemungut/senarai_ispeks',
        showOverlay: false,
        persistent: false,
        loading : false,
        reload: true,
        penyata_pemungut_id : null,
        form_cari: {},
        cari : {
          loading: false,
        },
        pemungut : [],
       
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Kutipan', route: '/kutipan' },
            { label: 'Ispeks Manual', route: 'kutipan.penyata_pemungut.ispeksmanual' }
          ],
          cari : { no_resit: ''},

          pilih : false
        }
         
  },
  methods: {

        detail() {
            
            // this.pemungut = [];
            this.showOverlay= true
            this.loading = true
            this.$zcomm.get(this.service_kutipan +"penyata_pemungut/senarai_ispeks" +"?no_penyata_pemungut=" +this.cari.no_penyata_pemungut+'&tarikh_lulus='+this.cari.tarikh_lulus+'&jabatan_id='+this.cari.jabatan_id+'&lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id)
                .then((res) => {
                    this.pemungut = res.data.items
                    this.showOverlay= false
                    this.loading = false
                });
            
        },
        cekPilih(){
            for (var i in this.pemungut) {
                this.pemungut[i].pilih = this.pilih
            }
        },

        // reset(){
        //       this.cari = {no_penyata_pemungut: '', tarikh_lulus: ''}
        //       this.detail()
        // },
        reset(){
            this.cari = {no_penyata_pemungut: '', tarikh_lulus: '', proses : 0}
            var url = window.route('kutipan.pemungut.ispeks_manual')+'?no_penyata_pemungut='+this.cari.no_penyata_pemungut+'&tarikh_lulus='+this.cari.tarikh_lulus+'&jabatan_id='+this.cari.jabatan_id+'&lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&proses=0';
            this.$inertia.visit(url, { preserveScroll : true})
          },

        hantar() {
            var id = '';
            for (var i in this.pemungut) {
                if(this.pemungut[i].pilih == true){
                    id = this.pemungut[i].id+','+id
                }
            }
            if(id){
                // window.location.href = this.service_kutipan+'penyata_pemungut/ispeks_manual/'+id;
                // this.$zcomm.post(this.service_kutipan +"penyata_pemungut/ispeks_manual/", id)
                 this.$zcomm
                .post(this.service_kutipan + "penyata_pemungut/ispeks_manual/" +id)
                .then((res) => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }

                    this.$zutil.notify ("Penyata Pemungut Telah Berjaya Dihantar");
                    this.detail()
                  })
                  .catch(err => {

                  })
                  .finally(() => {

                  });
            }else{
                alert('sila pilih dulu.')
            }
        },



        hantarIspeks(id) {

            this.showOverlay= true
            this.loading = true
             this.$zcomm
                .post(this.service_kutipan + "penyata_pemungut/ispeks_manual/" +id)
                .then((res) => {
                    this.file = res.file;
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }

                    this.detail()
                    // this.$zutil.message('Fail berjaya dijana semula ke iSpeks. '+this.file )
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                    this.showOverlay= false
                    this.loading = false

                    this.$zutil.message('Fail berjaya dijana semula ke iSpeks. '+this.file )
                  });

        },
      
    


  },
  watch: {
     
  },
  mounted() {
    this.dialog.width = 900
    
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>